import "./UwPolicyList.scss";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import CircularButton, { CustomButtonMenu, CustomLoadingButton } from "../../../components/ui/CustomButton";
import { motion } from "framer-motion";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { ScaleLoader } from "react-spinners";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer";
import { sanitizeText } from "../../../utils/genericFunctions";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { GrNotes } from "react-icons/gr";
import { MdAdd, MdClose, MdOutlineAdd, MdArrowBackIos } from "react-icons/md";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import UwRegister from "../uwRegister/UwRegister";


const UwPolicyList = ({ passedDocType = null }) => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const parts = location.pathname.split("/");
  const [riskNotes, setRiskNotes] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });
  const [reportGroupArray, setReportKeysArray] = useState(["policy-listings"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const showBack = location.state?.showBack || "N";

  const getDocumentType = () => {
    if (parts[2] === "policy") {
      return "Policy";
    } else if (parts[2] === "risknote") {
      return "RiskNote";
    } else {
      return passedDocType;
    }
  };


  const fetchRiskNotes = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/uwPolicy/findAll", {
        result_limit: 3,
        pl_type: passedDocType || getDocumentType()
      });
      setRiskNotes(res.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "underReview") {

      }
    } catch (err) {
      console.log(err);
    }
    setIsConfirmDialogOpen(false);
  };

  const handleSearchRiskNotes = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/uwPolicy/search", {
          search_input: searchTerm,
          result_limit: 100,
          pl_type: ["broker", "agent"].includes(currentUser?.token_org_type) ? "RiskNote" : "Policy",
          pl_subagent_ent_code: currentUser?.usr_entity_code
        });
        setRiskNotes(res.data);
      } else {
        fetchRiskNotes();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const menus = [
    {
      _id: "home",
      title: t('home'),
    },
    {
      _id: "list",
      title: t('list'),
    },
  ];



  useEffect(() => {
    fetchRiskNotes();
  }, [parts[2]]);

  useEffect(() => {
    setSelectedMenu(menus[0]);
  }, []);


  return (
    <motion.div
      className="uw-policy-list"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="uw-policy-list-main-wrapper">
          <motion.div className="list-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}>
            <div className="list-navbar">
              <div className="list-navbar-left">
                <span className="page-title">{getDocumentType() === "RiskNote" ? t('riskNotes').toUpperCase() : t('policies').toUpperCase()}</span>
              </div>
              <div className="list-navbar-right">
                <div className="home-menus-wrapper">
                  {menus?.map((row, index) => (
                    <React.Fragment key={row._id}>
                      <span style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                        <CustomButtonMenu
                          className="single-menu"
                          currentButton={selectedMenu?._id === row?._id}
                          currentTheme={currentTheme}
                          onClick={async () => {
                            try {
                              setSelectedMenu(row);
                              // if (row?._id === "list") {
                              //   await fetchBankAccounts();
                              //   await fetchPayingFor();
                              //   await fetchBranches();
                              //   await fetchCurrencies();
                              //   await fetchStatuses();
                              //   setDates();
                              // }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          {row?.title}
                        </CustomButtonMenu>
                      </span>
                      {index < menus.length - 1 && <span className="separator-v" />}
                    </React.Fragment>
                  ))}
                </div>
                <span className="separator-v" />
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<RefreshIcon />}
                  onClick={fetchRiskNotes}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0ea5a4"
                  tooltip={"Add new document"}
                  endIcon={<MdAdd />}
                  currentTheme={currentTheme}
                  onClick={() => navigate(`/uw/${getDocumentType()?.toLowerCase()}/new`)}
                >
                  {getDocumentType() === "RiskNote" ? t('newNote') : t('newPolicy')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>}
              </div>
            </div>
            {selectedMenu?._id === "home" && (
              <div className="list-content">
                <GrNotes className="icon" />
                <h1 className="all-hero-title">{getDocumentType() === "RiskNote" ? t('createAndManageRiskNotes') : t('createAndManagePolicies')}</h1>
                <p className="all-hero-sub"> {getDocumentType() === "RiskNote" ? t('createAndManageRiskNotesDesc') : t('createAndManagePoliciesDesc')}</p>
                {/* Search */}
                {riskNotes?.length > 0 &&
                  <div className="homeSearch">
                    <FiSearch className="homeSearchIcon" />
                    <input
                      className="homeSearchInput"
                      type="text"
                      placeholder={t('search')}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearchRiskNotes();
                      }}
                    />
                    {searchTerm?.length > 0 ? (
                      <MdClose
                        className="homeSearchClear"
                        onClick={async () => {
                          try {
                            await fetchRiskNotes();
                            setSearchTerm("");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      />
                    ) : (
                      <span className="homeSearchClearPlaceholder" />
                    )}
                  </div>}
                {riskNotes?.length === 0 &&
                  <div className="zero-policies-view">
                    <MdOutlineAdd
                      className="add-icon"
                      onClick={() => navigate(`/uw/${getDocumentType()?.toLowerCase()}/new`)} />
                    <p>{["broker", "agent"].includes(currentUser?.token_org_type) ? t('firstRiskNote') : t('firstPolicy')}</p>
                  </div>}
                <div className="cards-wrapper">
                  {riskNotes.map((row) => (
                    <div className={`single-card c${row.pl_end_code}`}
                      key={row._id}
                      onClick={() => {
                        try {
                          navigate(`/uw/${getDocumentType()?.toLowerCase()}/${row._id}`, { state: row });
                        } catch (error) {
                          console.log(error)
                        }
                      }}
                    >
                      <div className="single-card-top">
                        <span className="category">
                          <h1 className="main-title two-lines">
                            {row?.insured_details_xx?.ent_name || ""}
                          </h1>
                          <h1 className="sub-title twolines" style={{ fontSize: "12px" }}>
                            {row.end_name_xx}
                          </h1>
                        </span>
                      </div>
                      <div className="single-card-center">
                        <h1 className="sub-title-twolines" style={{ fontSize: "16px", color: "inherit", margin: "5px 0px" }}>
                          {row.pl_term_code ? row.pl_term_code_xx?.term_name : row.product_name_xx}
                        </h1>
                        <h1 className="sub-title-twolines" style={{ fontSize: "12px", margin: "7px 0px" }}>
                          {`VIA: ${row?.carrier_details_xx?.ent_name || "DIRECT"}`}
                        </h1>
                        {["Policy"].includes(getDocumentType()) && <span className="main-title" style={{ fontSize: "16px" }}>{row.pl_no}</span>}
                        {!["Policy"].includes(getDocumentType()) && <span className="main-title" style={{ fontSize: "16px" }}>{row.pl_risk_note_no}</span>}
                        <span className={`status ${row.pl_status}`}>{row.pl_status}</span>
                      </div>
                      <div className="single-card-bottom">
                        <WorkedOnBy name={row.updated_by_name_xx} photoUrl={row.updated_by_photo_url_xx} time_ago_xx={row.time_ago_xx} />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="list-footer">
                  <button className="overlay-button" onClick={() => setIsOverlayOpen(true)}>
                    {t('how')}
                  </button>
                </div>
              </div>
            )}
            {selectedMenu?._id === "list" &&
              <UwRegister />
            }
          </motion.div>
          {isOverlayOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <span className="main-title">{t('help')}</span>
                  <CircularButton currentTheme={currentTheme} onClick={() => setIsOverlayOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                </div>
                <div className="overlay-content">
                  <VideoPlayer videoUrl="creatingRiskNotes" />
                </div>
                <div className="overlay-actions">
                </div>
              </div>
            </motion.div>
          )}
        </div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docType: "AllPolicies",
                  docId: "1",
                  clientEmail: "",
                  clientEntCode: "",
                  clientEntName: ""
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={() => setIsNotifyDialogOpen(false)}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: sanitizeText(notifyDialogText) }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
    </motion.div>
  );
};

export default UwPolicyList;
